export default {
  chart: {
    type: 'area',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    height: 298,
  },
  credits: {
    enabled: false,
  },
  exporting: {
    enabled: false,
  },
  legend: {
    enabled: false,
  },
  navigator: {
    enabled: true,
    outlineColor: 'rgba(225, 240, 245, .7)',
    outlineWidth: 0,
    series: {
      type: 'areaspline',
      color: '#005fa5',
      fillOpacity: 1,
      dataGrouping: {
        smoothed: true,
      },
      lineWidth: 1,
      marker: {
        enabled: false,
      },
    },
    xAxis: {
      tickWidth: 0,
      lineWidth: 0,
      gridLineWidth: 1,
      tickPixelInterval: 200,
      labels: {
        align: 'left',
        x: -20,
        y: -4,
        style: {
          color: '#FFF',
        },
      },
    },
  },
  plotOptions: {
    area: {
      color: 'rgba(225, 240, 245, .7)',
      lineColor: 'rgba(13, 101, 165, 1)',
      lineWidth: 1,
      step: true,
    },
    series: {
      gapSize: 0,
      /**
       * When using week graph, we ask for 200 points per day,
       * but also insert objects on the start and end of each
       * day. This results in 200 * 5 + (2 * 5) = 1010 points.
       *
       * Bump turboThreshold so we have a bit more margin before
       * it breaks.
       */
      turboThreshold: 3500,
      dataGrouping: {
        enabled: false,
      },
      tooltip: {
        valueDecimals: 2,
      },
      threshold: null,
    },
  },
  rangeSelector: {
    enabled: false,
  },
  scrollbar: {
    enabled: false,
  },
  tooltip: {
    dateTimeLabelFormats: {
      millisecond: '%A, %b %e, %H:%M:%S.%L',
      second: '%A, %b %e, %H:%M:%S',
      minute: '%A, %b %e, %H:%M',
      hour: '%A, %b %e, %H:%M',
      day: '%A, %b %e, %Y',
      week: '%A, %b %e, %Y',
      month: '%B %Y',
      year: '%Y',
    },
  },
  xAxis: {
    lineWidth: 2,
    lineColor: '#dadada',
    minorTickColor: '#000000',
    ordinal: false,
    startOnTick: false,
    gapGridLineWidth: 0,
    gapSize: 0,
  },
  yAxis: {
    gridLineColor: '#e6e6e6',
    gridLineDashStyle: 'line',
    gridLineWidth: 2,
    labels: {
      align: 'left',
      x: 10,
      y: 5,
    },
  },
  zoom: {
    enabled: false,
  },
};
